module.exports = __webpack_public_path__ + "static/6 - Raptor 3-3f417a2edfa3c765d1ea5ca41765f70a.jpg";